var React = require('react');

function Hamburger (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M240 0C107.452 0 0 107.452 0 240s107.452 240 240 240c132.486-.15 239.85-107.514 240-240C480 107.452 372.548 0 240 0zm0 464C116.288 464 16 363.712 16 240S116.288 16 240 16c123.653.141 223.859 100.347 224 224 0 123.712-100.288 224-224 224z","key":0}),React.createElement("path",{"d":"M336 232H144a8 8 0 0 0 0 16h192a8 8 0 0 0 0-16zM336 312H144a8 8 0 0 0 0 16h192a8 8 0 0 0 0-16zM336 152H144a8 8 0 0 0 0 16h192a8 8 0 0 0 0-16z","key":1})]);
}

Hamburger.defaultProps = {"viewBox":"0 0 480 480"};

module.exports = Hamburger;

Hamburger.default = Hamburger;
